import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell.tsx";
import { Toaster } from "@/components/ui/toast.tsx";
import type { RouterContext } from "../router.tsx";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: () => <p className="p-6">页面不存在</p>,
});

function RootLayout() {
  return (
    <>
      <AppShell>
        <Outlet />
      </AppShell>
      <Toaster />
    </>
  );
}
